/* Sooler Studio: open the native search field from its mobile icon. */
(() => {
  const HEADER_SELECTOR = '.header--sooler-mobile-search-icon';
  const mobileQuery = window.matchMedia('(max-width: 1067px)');

  const setup = (header) => {
    if (header.dataset.soolerMobileSearchReady === 'true') return;
    const trigger = header.querySelector('.thb-secondary-search');
    const searchForm = header.querySelector('search-form');
    const input = searchForm?.querySelector('input[type="search"]');
    const capture = searchForm?.querySelector('.searchform--click-capture');
    if (!trigger || !searchForm || !input) return;

    header.dataset.soolerMobileSearchReady = 'true';
    trigger.setAttribute('aria-controls', input.id);
    trigger.setAttribute('aria-expanded', 'false');

    const syncPanelHeight = () => {
      if (!mobileQuery.matches || !header.classList.contains('sooler-mobile-search-open')) return;
      searchForm.style.setProperty('--sooler-mobile-search-panel-height', `${searchForm.offsetHeight}px`);
    };

    const close = () => {
      header.classList.remove('sooler-mobile-search-open');
      trigger.setAttribute('aria-expanded', 'false');
      searchForm.close?.();
      input.blur();
    };

    const open = () => {
      header.classList.add('sooler-mobile-search-open');
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => {
        syncPanelHeight();
        input.focus();
      });
    };

    trigger.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;
      event.preventDefault();
      if (header.classList.contains('sooler-mobile-search-open')) close();
      else open();
    });

    capture?.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && header.classList.contains('sooler-mobile-search-open')) close();
    });
    mobileQuery.addEventListener?.('change', (event) => {
      if (!event.matches) close();
    });
    window.addEventListener('resize', syncPanelHeight, { passive: true });
  };

  const initialize = (root = document) => {
    if (root.matches?.(HEADER_SELECTOR)) setup(root);
    root.querySelectorAll?.(HEADER_SELECTOR).forEach(setup);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
